import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { url } from "../../Config/Config";
import { encodeID } from '../../utils/Helper';
import React from 'react';
import { toast } from 'react-toastify';



export const LinkButtons = ({ pageLink,subPageLink, pageID,showEdit, showView, showDelete, onClick ,showTicket , showEdit_disable }:any) => {
    return (
        <Fragment>
             {showEdit && (
            // <li>
                    <Link to={`${url}/${pageLink}/${encodeID(pageID)}`} className="btn btn-primary me-2">
                     <i className="fas fa-edit" title="Edit"></i>
                    </Link>
            // </li>
                 )}

       {showEdit_disable && (
            // <li>
                    <a  className="btn btn-primary me-2"  >
                     <i className="fas fa-edit" title="Edit"></i>
                    </a>
            // </li>
                 )} 
                 {showView && (
            // <li>
                        <Link to={`${url}/${pageLink}/${encodeID(pageID)}`} className="btn btn-info me-2">
                            <i className="fas fa-eye" title="View"></i>
                        </Link> 
            // </li>
            )}
             {showDelete && (
                // <li>
                        <Link to={`${url}/${pageLink}`} className="btn btn-danger-delete text-white">
                            <i className="fas fa-trash-alt" title="Delete"></i>
                        </Link>
                // </li>
            )}
           {showTicket && (
                // <li>
                <Link to={`${url}/${pageLink}/${encodeID(pageID)}/${subPageLink}`} className="btn btn-info me-2">
                            <i className="bx bxs-coupon" title="Ticket"></i>
                        </Link>
                // </li>
            )}
        </Fragment>
    );
}


// import { Fragment } from 'react';
// import { Link } from 'react-router-dom';
// import { url } from "../../Config/Config";
// import { encodeID } from '../../utils/Helper';

// const LinkButtons = () => {
//     return (
//         <Fragment>
//                <li><Link className="btn btn-primary" to="#"><i className="fas fa-edit" title="Edit"></i></Link></li>
//           <li><Link className="btn btn-info" to="#"><i className="fas fa-eye" title="View"></i><span className="ms-1">View</span></Link></li>
//           <li><Link className="btn btn-danger-delete text-white" to="#"><i className="fas fa-trash-alt" title="Delete"></i><span className="ms-1">Delete</span></Link></li>
    

//         </Fragment>
//     );
// }

// export default LinkButtons;